// src/components/Header/Header.jsx
import React, { useEffect, useState } from "react";
import { TiArrowSortedDown } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import UserAvater from "../../assets/images/user-avater.png";
import Sidebar from "../layouts/PopSidebar";
import { get } from "../../utility/fetch";
import { Badge, IconButton } from "@mui/material";
import { IoNotifications } from "react-icons/io5";

// Import the new CSS file
import "./header.css";

const Header = ({ history }) => {
  const [userPix, setUserPix] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [imgHasError, setImgHasError] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const userInfo = JSON.parse(localStorage.getItem('USER_INFO'));
  const navigate = useNavigate();

  const handleImageLoad = () => {
    setIsImageLoading(false);
    setImgHasError(false);
  };

  const convertImageToBase64 = async (url) => {
    try {
      const response = await fetch(url, { mode: 'cors' });
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result); // base64 string
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Error converting image to Base64:', error);
      return null;
    }
  };


  const handleImageError = () => {
    setIsImageLoading(false);
    setImgHasError(true);
    // Note: The `src` prop is updated to use sessionStorage.getItem("profilePic") || userPix ||  directly on error, so no need to set state here.
  };

  const getOrgDetails = async () => {
    setIsImageLoading(true);
    setImgHasError(false);
    try {
      const providerId = sessionStorage.getItem("healthCareProviderId");
      if (!providerId) {
        console.warn("healthCareProviderId not found in sessionStorage.");
        setIsImageLoading(false);
        setUserPix(UserAvater); // Fallback to default
        return;
      }

      let res = await get(`/healthcareprovider/healthcareprovider/id/${providerId}`);

      if (res?.logoPath) {
        setUserPix(res.logoPath);
        sessionStorage.setItem("profilePic", res.logoPath);
        sessionStorage.setItem('location', res?.location);
        sessionStorage.setItem('phone', res?.phone);
        sessionStorage.setItem('letterHead', res?.logoBase64);

        if ((res.logoPath && !res.logoPath.startsWith("data:image"))) {
          convertImageToBase64(res.logoPath).then((base64) => {
            if (base64) {
              sessionStorage.setItem("profilePic64", base64);
              console.log("Logo converted to Base64 and stored.");
              console.log(base64);
            }
          });
        }
      } else {
        setUserPix(UserAvater);
      }
    } catch (err) {
      console.error("Error fetching organization details for logo:", err);
      setImgHasError(true);
      setUserPix(UserAvater);
    } finally {
      setIsImageLoading(false); // Ensure loading state is turned off regardless of outcome
    }
  };

  useEffect(() => {
    getOrgDetails();
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Determine the final image source based on state
  const finalUserPix = imgHasError || !userPix ? UserAvater : userPix;

  return (
    <header className="header-container">
      <div className="header-left">
        <span>{userInfo?.role}</span>
      </div>
      <div className="header-right">
        <IconButton onClick={() => navigate("/notifications")} className="notification-icon">
          <Badge badgeContent={0} color="error">
            <IoNotifications />
          </Badge>
        </IconButton>
        <div
          role="presentation"
          onClick={toggleSidebar}
          className="user-avater-details"
        >
          <div className="right-text">
            <p className="name">
              {userInfo?.firstName} {userInfo?.lastName}
            </p>
            <h3 className="role">
              {sessionStorage?.getItem("healthCareProviderName") || "nurse"}
            </h3>
          </div>
          <div className="user-avatar-wrapper">
            {isImageLoading ? (
              <div className="skeleton-loader skeleton-avatar"></div>
            ) : (
              <img
                src={sessionStorage.getItem("profilePicture") || userPix || UserAvater}
                alt="user avatar"
                onError={handleImageError}
                onLoad={handleImageLoad}
              />
            )}
          </div>
          <div className="arrow">
            <TiArrowSortedDown />
          </div>
        </div>
      </div>

      <Sidebar
        isOpen={isSidebarOpen}
        onClose={toggleSidebar}
        userInfo={userInfo}
      />
    </header>
  );
};

export default Header;